import request from '../util/request';

const apis = {
    addComplain() {
        return request({
            url: " /V1/addComplain",
            method: 'post',
        })
    }

}
export default apis